const mapper_options = {
  endpoint: 'reporting/pulse/engagement',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      brand: {
        foreignKey: 'brand_id',
        localField: 'brand'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('pulse_engagement', mapper_options)
}
